import { Flex, TextField } from '@iheartjane/reefer';
import { clsx } from 'clsx';

import { AddressAutocomplete } from '../addressAutocomplete/addressAutocomplete';
import type { CountryOptions } from '../addressAutocomplete/addressAutocomplete.types';

import styles from './deliveryAddressFields.module.css';

export interface DeliveryAddressFieldsProps {
  /** Error message displayed under the address autocomplete */
  addressErrorMessage?: string;
  /** Label for the address field */
  addressLabel?: string;
  /** Country codes to restrict autocomplete results */
  countries?: CountryOptions[];
  /** Pre-filled address string */
  defaultAddress?: string;
  /** Pre-filled apt/unit value */
  defaultStreet2?: string;
  /** Disable mobile-specific input styling (used in headless contexts) */
  disableMobileInputStyling?: boolean;
  /** The Google Places API key to use for the autocomplete */
  googlePlacesKey?: string;
  /** Called when the address text changes (useful for clearing errors) */
  onAddressChange?: (value: string) => void;
  /** Called when user selects an address from autocomplete */
  onAddressSelection: (address: string) => void;
  /** Called when the street2 field loses focus */
  onStreet2Blur: (street2: string) => void;
}

export const DeliveryAddressFields = ({
  addressErrorMessage,
  addressLabel = 'Delivery address',
  countries,
  defaultAddress = '',
  defaultStreet2 = '',
  disableMobileInputStyling,
  googlePlacesKey,
  onAddressChange,
  onAddressSelection,
  onStreet2Blur,
}: DeliveryAddressFieldsProps) => {
  return (
    <div className={clsx(styles['container'])}>
      <Flex width="100%">
        <AddressAutocomplete
          clearIcon
          countries={countries}
          defaultValue={defaultAddress}
          disableMobileInputStyling={disableMobileInputStyling}
          errorMessage={addressErrorMessage}
          googlePlacesKey={googlePlacesKey}
          label={addressLabel}
          name="delivery-address"
          onChange={onAddressChange}
          onSelection={onAddressSelection}
        />
      </Flex>
      <Flex className={styles['textField']} flexDirection="column">
        <TextField
          defaultValue={defaultStreet2}
          disableMobileInputStyling={disableMobileInputStyling}
          name="additional_address"
          onBlur={(value) => onStreet2Blur(value)}
          label="Apt, unit, etc."
        />
      </Flex>
    </div>
  );
};
